export default __webpack_public_path__ + "static/media/dots-icon.86aad1c4.svg";